import { createSelector } from './selectorWrapper'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { pageSelectors } from './basicState'
import { isRetailSelector } from './requestContext'

export const showBtfProductDetailsSelector = createSelector(
  [isRetailSelector, pageSelectors.detail],
  (isRetail: boolean, detail?: WpsRuntime.atv.wps.DetailFragmentModelProps) =>
    Boolean(isRetail && detail) || Boolean(detail && detail.ratingBadge)
)

